import { PixiAssets } from './loadResources';

export const getGameImages = () => {
  return {
    ...(PixiAssets.get('gameImages')?.textures || {}),
    ...(PixiAssets.get('images')?.textures || {}),
    ...(PixiAssets.get('jackpot')?.textures || {}),
    ...(PixiAssets.get('infoSection')?.textures || {}),
    ...(PixiAssets.get('licenseImages')?.textures || {}),
    ...(PixiAssets.get('introImages')?.textures || {}),
  };
};
